import { AUTH_URLS, LOGIN_PAGE_URL, PASSWORD_TOKEN_PAGES } from './constants';

export const isPublicAuthPage = (pathname: string) => {
  return AUTH_URLS.includes(pathname) || pathname === LOGIN_PAGE_URL;
};

export const isTrackRoute = (pathname: string) => {
  return pathname.startsWith('/track');
};

export const isPasswordTokenPage = (pathname: string) => {
  return PASSWORD_TOKEN_PAGES.includes(pathname);
};

export const hasTokenParam = (search: string) => {
  const searchParams = new URLSearchParams(search);
  return !!searchParams.get('token');
};

export const shouldSkipAuth = (pathname: string, search: string) => {
  return (
    isPublicAuthPage(pathname) ||
    isTrackRoute(pathname) ||
    (isPasswordTokenPage(pathname) && hasTokenParam(search))
  );
};
